import { useState } from 'react';
import ModalComponent from 'src/components/Modal/ModalComponent';
import { useUserContext } from 'src/contexts/UserContext';
import { OrdersService } from 'src/services/Orders';
import { formatPrice } from 'src/services/utils';

const TrackingModalUpdate = ({
  closeModal,
  trackingPayload,
  orderUUID,
  setTrackingPayload,
  fetchOrderDetail,
}) => {
  const [loading, setLoading] = useState(false);

  const { showToast, accessToken } = useUserContext();

  const updatePedido = async () => {
    setLoading(true);

    try {
      await OrdersService.updateNewOrderTracking({
        uuid: orderUUID,
        accessToken,
        trackingPayload,
      });

      setTrackingPayload({});

      await fetchOrderDetail();
      window.scroll(0, 0);
      showToast(`O dado foi atualizado com sucesso!`, 'success');
    } catch (error) {
      window.scroll(0, 0);
      showToast('Ocorreu um erro ao atualizar o pedido', 'error');
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  return (
    <ModalComponent title="Atualização de Pedido" closeModal={closeModal}>
      <p className="card-text pb-3">Você confirma essa atualização?</p>
      <h4>Confira as informações:</h4>
      {trackingPayload.shippingDate && (
        <p className="mb-1">
          Data de postagem:{' '}
          {new Date(trackingPayload.shippingDate).toLocaleString('pt-BR')}
        </p>
      )}
      {trackingPayload.finalShippingCost !== undefined && (
        <p className="mb-1">
          Custo de envio: {formatPrice(trackingPayload.finalShippingCost)}
        </p>
      )}

      {trackingPayload.shippingCompanyName && (
        <p className="mb-1" data-testid="shippingCompanyName">
          Transportadora: {trackingPayload.shippingCompanyName}
        </p>
      )}

      {trackingPayload.trackingUrl && (
        <p className="mb-1">Link de rastreio: {trackingPayload.trackingUrl}</p>
      )}

      {trackingPayload.trackingCode && (
        <p className="mb-1">
          Código de rastreio: {trackingPayload.trackingCode}
        </p>
      )}

      {trackingPayload.trackingInstructions && (
        <p
          className="mb-1"
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          Orientações para rastreio: {trackingPayload.trackingInstructions}
        </p>
      )}

      <button
        className="btn btn-confirm mt-4"
        disabled={loading}
        onClick={updatePedido}
      >
        {loading ? (
          <div className="spinner-border " role="status" />
        ) : (
          'Confirmar'
        )}
      </button>
    </ModalComponent>
  );
};

export default TrackingModalUpdate;
